<template>
  <div v-if="show" class="margin-bottom-m">
    <h2 class="h5 margin-bottom-xs">
      {{ ORDER_DETAILS.pickupInfoText }}
    </h2>
    <div class="cell large-8">
      <p v-if="data.differentExchangeAddress" class="exchange-address-text margin-bottom-xs">
        {{ ORDER_DETAILS.exchangeInformationMessage }}
      </p>
    </div>
    <div class="margin-bottom-xs">
      <div v-if="data.storeName" v-text="data.storeName"></div>
      <div v-if="data.address.addressLine1" v-text="data.address.addressLine1"></div>
      <div v-if="data.address.addressLine2" v-text="data.address.addressLine2"></div>
      <div v-if="data.address.city || data.address.state || data.address.postalCode">
        {{ data.address.city }}
        {{ data.address.state }}
        {{ data.address.zipCode }}
      </div>

      <div v-if="storeHoursResults">
        <h6 class="margin-bottom-xs margin-top-xs">
          {{ ORDER_DETAILS.storeHoursLabel }}
        </h6>
        <div v-for="(item, index) in storeHoursResults" :key="index" class="margin-bottom-xxs">
          <div v-text="item.label"></div>
          <div v-text="item.timings"></div>
        </div>
      </div>

      <h6 class="margin-bottom-xs margin-top-xs">
        {{ ORDER_DETAILS.pickupPersonLabel }}
      </h6>
      <div v-if="fullName" v-text="fullName"></div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { ORDER_DETAILS } from 'config';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const show = computed(() => props.data && typeof props.data === 'object' && Object.keys(props.data).length);
const fullName = computed(() => {
  const { pickUpFirstName, pickUpLastName } = props.data;
  if (pickUpFirstName && pickUpLastName) {
    return `${pickUpFirstName} ${pickUpLastName}`;
  }
  return pickUpFirstName || pickUpLastName || '';
});
const storeHoursResults = computed(() => {
  const result = [];
  const { storeHours } = props.data;
  if (storeHours && storeHours !== null && storeHours !== '') {
    const storeHourArray = storeHours.split(', ');
    storeHourArray.forEach((item) => {
      const [label, timings] = item.split(': ');
      result.push({ label, timings });
    });
  }
  return result;
});
</script>
<style lang="scss" scoped>
.exchange-address-text {
  color: $gray-1-color;
  word-break: break-word;
  white-space: break-spaces;
}
</style>
